// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Form from 'antd/lib/form';
import message from 'antd/lib/message';
// COMPONENTS
import EmailInput from 'components/inputs/EmailInput';
import TextInput from 'components/inputs/TextInput';
import CountryInput from 'components/inputs/CountryInput';
import SalesTaxInput from 'components/inputs/SalesTaxInput';
import ImageUploadInput from 'components/inputs/ImageUploadInput';
import Button from 'components/common/Button';
import SelectCurrency from 'components/inputs/SelectCurrency';
import Col from 'components/common/Col';
import Row from 'components/common/Row';
import FormItem from 'components/common/FormItem';

// EXPORTED COMPONENT
// ====================================
class StudioForm extends React.PureComponent {
  state = {
    email: this.props.studio.email,
    title: this.props.studio.title,
    street1: this.props.studio.street1,
    street2: this.props.studio.street2,
    website: this.props.studio.website,
    phone: this.props.studio.phone,
    description: this.props.studio.description,
    country: this.props.studio.country,
    state: this.props.studio.state,
    city: this.props.studio.city,
    zip: this.props.studio.zip,
    salesTax: this.props.studio.salesTax,
    currency: this.props.studio.currency,
    image: this.props.studio.image,
    loading: false,
  };

  onChange = newValue => {
    this.setState(newValue);
  };

  onSubmit = () => {
    if (!this.state.title) {
      return message.error('Organization name is reqiured');
    }
    if (!this.state.email) {
      return message.error('Organization email is reqiured');
    }
    if (!this.state.salesTax && this.state.salesTax !== 0) {
      return message.error('Organization salesTax is reqiured');
    }
    if (!this.state.currency) {
      return message.error('Organization currency is reqiured');
    }
    this.props.handleSubmit(this.state);
  };

  render() {
    return (
      <Form onSubmit={this.onSubmit} id="user-form">
        <Row gutter={20} style={{ marginBottom: 20 }}>
          <Col xs={24}>
            <FormItem
              containerProps={{
                style: { display: 'flex', justifyContent: 'center' },
              }}
            >
              <div style={{ margin: 25 }}>
                <ImageUploadInput
                  cloudinaryOptions={{ croppingAspectRatio: 0.5, maxImageHeight: 150, maxImageWidth: 150 }}
                  value={this.state.image}
                  imageWidth="auto"
                  imageHeight={75}
                  onChange={image => this.onChange({ image })}
                />
              </div>
            </FormItem>
          </Col>
          <Col xs={24}>
            <FormItem>
              <label>Studio Name</label>
              <TextInput onChange={title => this.onChange({ title })} value={this.state.title} />
            </FormItem>
          </Col>
          <Col xs={24}>
            <FormItem>
              <label>Email</label>
              <EmailInput onChange={email => this.onChange({ email })} value={this.state.email} />
            </FormItem>
          </Col>
          <Col xs={24} md={16}>
            <FormItem>
              <label>Street 1</label>
              <TextInput onChange={street1 => this.onChange({ street1 })} value={this.state.street1} />
            </FormItem>
          </Col>
          <Col xs={24} md={8}>
            <FormItem>
              <label>Street 2</label>
              <TextInput onChange={street2 => this.onChange({ street2 })} value={this.state.street2} />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>State / Province</label>
              <TextInput onChange={state => this.onChange({ state })} value={this.state.state} />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>Country</label>
              <CountryInput onChange={country => this.onChange({ country })} value={this.state.country} />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem />
            <label>Sales Tax</label>
            <div />
            <SalesTaxInput onChange={salesTax => this.onChange({ salesTax })} value={this.state.salesTax} />
          </Col>
          <Col xs={24} md={12}>
            <FormItem />
            <label>City</label>
            <TextInput onChange={city => this.onChange({ city })} value={this.state.city} />
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>Phone</label>
              <TextInput onChange={phone => this.onChange({ phone })} value={this.state.phone} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>Website</label>
              <TextInput onChange={website => this.onChange({ website })} value={this.state.website} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>Postal Code</label>
              <TextInput onChange={zip => this.onChange({ zip })} value={this.state.zip} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>Currency</label>
              <SelectCurrency onChange={currency => this.onChange({ currency })} value={this.state.currency} />
            </FormItem>
          </Col>
        </Row>
        <Button disabled={this.props.loading} loading={this.props.loading} onClick={this.onSubmit} fullWidth>
          {!this.props.loading ? this.props.onOkText : 'Submitting...'}
        </Button>
        {/* <ErrorList errors={errors} /> */}
      </Form>
    );
  }
}

// PROPS
// ====================================
StudioForm.defaultProps = {
  user: {},
  onOkText: 'Submit',
};

// EXPORT
// ====================================
export default Form.create()(StudioForm);



// WEBPACK FOOTER //
// ./src/components/forms/StudioForm/index.js